/**
 * Checks if a widget of a given type exists in the page editor.
 * @param widgetType The type of widget to check for.
 * @param rows The rows of the page editor.
 * @returns True if the widget exists, false otherwise.
 */
export function pageEditorIncludesWidget(
    widgetType: string,
    rows?: { columns?: { widgets?: { type?: string }[] }[] }[],
): boolean {
    if (!rows) {
        return false
    }

    return rows.some((row) =>
        row.columns?.some((column) =>
            column.widgets?.some((widget) => widget?.type === widgetType),
        ),
    )
}

export default pageEditorIncludesWidget
